import { Component, OnInit } from '@angular/core';
import {ParametreService} from '../../main-parametre/parametre.service';


@Component({
    selector: 'app-add-menu',
    templateUrl: './add-menu.component.html',
    styleUrls: ['./add-menu.component.scss']
})
export class AddMenuComponent implements OnInit {
    options = ['Ajouter catégorie', 'Ajouter unité', 'Ajouter marque'];

    constructor(private parametreService: ParametreService) {}

    ngOnInit(): void {
        console.log('AddMenuComponent initialized');
    }

    selectOption(option: string): void {
        const subType = option.replace('Ajouter ', '').toLowerCase();
        console.log('Selected option:', option, 'subType:', subType);
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const idStation = currentUser?.stations?.[0]?.id || 0;
        if (idStation) {
            this.parametreService.triggerAddItem(subType, idStation);
        } else {
            console.error('No station ID found in localStorage');
        }
    }
}
